import api from "../../api";
import { v4 as uuidv4 } from "uuid";
import { getCookie } from "../../mixins/cookies";

function initialState() {
  return {
    appID: null,
    appFilters: {
      newsPersonalisation: [],
      newsFilter: [
        {
          id: "global",
          value: true,
        },
      ],
      eventFilter: [
        {
          id: "global",
          value: true,
        },
      ],
      essentialFilter: [
        {
          id: "global",
          value: true,
        },
      ],
      newsletterFilter: [
        {
          id: "global",
          value: true,
        },
      ],
    },
    register: null,
    registerUUID: null,
    showPersonalisationCard: true,
    loggedIn: true,
    user: null,
    userRetries: 0,
    whatsNewHistory: [],
  };
}

const userModule = {
  state: initialState,
  getters: {
    appFilters: (state) => state.appFilters,
    appID: (state) => state.appID,
    register: (state) => state.register,
    registerUUID: (state) => state.registerUUID,
    showPersonalisationCard: (state) => state.showPersonalisationCard,
    loggedIn: (state) => state.loggedIn,
    user: (state) => state.user,
    userRetries: (state) => state.userRetries,
    whatsNewHistory: (state) => state.whatsNewHistory,
  },
  mutations: {
    SET_APPID: function(state) {
      state.appID = !state.appID ? uuidv4() + "Android" : state.appID;
    },
    SET_APPFILTER: function(state, filter) {
      state.appFilters[filter.key] = filter.value;
    },
    REMOVE_SCHOOL_FILTER: function(state, schoolId) {
      for (let filter in state.appFilters) {
        state.appFilters[filter] = state.appFilters[filter].filter((filter) => {
          return filter.id !== schoolId;
        });
      }
    },
    RESET_PERSONALISATION: function(state) {
      state.appFilters.newsPersonalisation.map((school) => {
        school.filters.map((filter) => {
          filter.value = false;
          return filter;
        });
        return school;
      });
      state.appFilters.newsFilter.map((school) => {
        return (school.value = false);
      });
    },
    TOGGLE_PERSONALISATION: function(state, schoolId) {
      state.appFilters.newsPersonalisation.map((school) => {
        if (school.id === schoolId) {
          let value = school.filters.find(
            (filter) => filter.id === "Get all updates"
          ).value;
          school.filters.map((filter) => {
            filter.value = !value;
            return filter;
          });
          return school;
        }
        return school;
      });
    },
    SET_REGISTER: function(state, data) {
      state.register = data;
    },
    SET_REGISTER_UUID: function(state, data) {
      state.registerUUID = data;
    },
    RESET_USER: function(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
    TOGGLE_PERSONALISATION_CARD: function(state, value) {
      state.showPersonalisationCard = value;
    },
    TOGGLE_LOGIN: function(state, value) {
      state.loggedIn = value;
    },
    SET_USER_DATA: function(state, value) {
      state.user = value;
    },
    SET_USER_RETRIES: function(state, value) {
      state.userRetries = value;
    },
    TOGGLE_SCHOOL_NEWS_FILTER: function(state, value) {
      if (value.tag !== undefined) {
        let visible = state.appFilters.newsFilter.find(
          (school) => school.id === value.schoolId
        ).value;
        state.appFilters.newsFilter.find(
          (school) => school.id === value.schoolId
        ).value = !visible;
        let school = state.appFilters.newsPersonalisation.find(
          (school) => school.id === value.schoolId
        );
        school.filters.find((filter) => filter.id === value.tag).value = true;
      } else {
        let visible = state.appFilters.newsFilter.find(
          (school) => school.id === value.schoolId
        ).value;
        state.appFilters.newsFilter.find(
          (school) => school.id === value.schoolId
        ).value = !visible;
      }
    },
    SET_WHATS_NEW_HISTORY: function(state, value) {
      state.whatsNewHistory = [...state.whatsNewHistory, value];
    },
    RESET_WHATS_NEW_HISTORY: function(state) {
      state.whatsNewHistory = [];
    },
  },
  actions: {
    setAppFilter({ commit }, filter) {
      commit("SET_APPFILTER", filter);
    },
    setAppID({ commit }) {
      commit("SET_APPID");
      let appID = this.getters.appID;
      let fcmToken = getCookie("fcmToken");
      if (appID && fcmToken) {
        api.user.registerSchoolStatus(appID, fcmToken).then((response) => {
          commit("SET_REGISTER", response);
        });
      }
    },
    removeSchoolFromFilter({ commit }, schoolId) {
      commit("REMOVE_SCHOOL_FILTER", schoolId);
    },
    resetPersonalisation({ commit }) {
      commit("RESET_PERSONALISATION");
    },
    togglePersonalisation({ commit }, schoolId) {
      commit("TOGGLE_PERSONALISATION", schoolId);
    },
    registerApp({ commit }) {
      let appID = this.getters.appID;
      api.user.registerApp(appID).then((response) => {
        commit("SET_REGISTER_UUID", response);
      });
    },
    resetApp({ commit }) {
      commit("RESET_USER");
      commit("RESET_SCHOOLS");
      commit("RESET_NEWSLETTERS");
      commit("RESET_NEWS");
      commit("RESET_EVENTS");
      commit("RESET_NOTIFICATIONS");
    },
    togglePersonalisationCard({ commit }, value) {
      commit("TOGGLE_PERSONALISATION_CARD", value);
    },
    toggleLogin({ commit }, value) {
      commit("TOGGLE_LOGIN", value);
    },
    fetchUserData({ commit }) {
      let accessToken = getCookie("accessToken");
      let userRetries = this.getters.userRetries;
      if (accessToken) {
        userRetries++;
        commit("SET_USER_RETRIES", userRetries);
        api.user.fetchUserData(accessToken, userRetries).then((response) => {
          commit("SET_USER_DATA", response);
        });
      }
    },
    logout({ commit }) {
      commit("SET_USER_DATA", null);
    },
    setUserRetries({ commit }, value) {
      commit("SET_USER_RETRIES", value);
    },
    toggleSchoolNewsFilter({ commit }, data) {
      commit("TOGGLE_SCHOOL_NEWS_FILTER", data);
    },
    setWhatsNewHistory({ commit }, data) {
      commit("SET_WHATS_NEW_HISTORY", data);
    },
    resetWhatsNewHistory({ commit }) {
      commit("RESET_WHATS_NEW_HISTORY");
    },
  },
};
export default userModule;
